'use strict';

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, Symbol.toStringTag, {
  value: 'Module'
});

var trackSize = require('./track-size.js');

function trackElementsSize(options) {
  var getNodes = options.getNodes,
      _options$observeMutat = options.observeMutation,
      observeMutation = _options$observeMutat === void 0 ? true : _options$observeMutat,
      callback = options.callback;
  var cleanups = [];
  var firstNode = null;

  function trigger() {
    var elements = getNodes();
    firstNode = elements[0];
    var fns = elements.map(function (element, index) {
      return trackSize.trackElementSize(element, function (size) {
        callback(size, index);
      });
    });
    cleanups.push.apply(cleanups, _toConsumableArray(fns));
  }

  trigger();

  if (observeMutation) {
    var fn = trackMutation(firstNode, trigger);
    cleanups.push(fn);
  }

  return function () {
    cleanups.forEach(function (cleanup) {
      cleanup === null || cleanup === void 0 ? void 0 : cleanup();
    });
  };
}

function trackMutation(el, cb) {
  var _el$ownerDocument$def, _el$ownerDocument;

  if (!el || !el.parentElement) return;
  var win = (_el$ownerDocument$def = (_el$ownerDocument = el.ownerDocument) === null || _el$ownerDocument === void 0 ? void 0 : _el$ownerDocument.defaultView) !== null && _el$ownerDocument$def !== void 0 ? _el$ownerDocument$def : window;
  var observer = new win.MutationObserver(function () {
    cb();
  });
  observer.observe(el.parentElement, {
    childList: true
  });
  return function () {
    observer.disconnect();
  };
}

exports.trackElementsSize = trackElementsSize;